export default __webpack_public_path__ + "static/media/bluefir3.beeef326.png";